<template>
  <BaseCustomizeMetal componentCode="M" :useGodNameVerticalText="true" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalM",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 34px;
    left: 157px;
    @include betweenTableTablePro {
      top: 7px;
      left: 108px;
    }
    @include table {
      top: -5px;
      left: 82px;
    }
    @include phone {
      top: -8px;
      left: 67px;
    }
  }
  .templeName {
    height: 28px;
    width: 185px;
    .textContainer {
      width: 185px;
    }
  }
  .godName {
    width: 95px;
    height: 95px;
    writing-mode: vertical-lr;
    writing-mode: vertical-rl;
    .textContainer {
      width: 95px;
      height: 95px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .gift {
    width: 79px;
    height: 33px;
    .textContainer {
      width: 79px;
    }
  }
}
</style>
